//
// PostgreSQL reserved words
// see: https://www.postgresql.org/docs/current/sql-keywords-appendix.html
//

export const POSTGRESQL_RESERVED_WORDS = new Set([
  'AES128',
  'AES256',
  'ALL',
  'ALLOWOVERWRITE',
  'ANALYSE',
  'ANALYZE',
  'AND',
  'ANY',
  'ARRAY',
  'AS',
  'ASC',
  'ASYMMETRIC',
  'AUTHORIZATION',
  'BACKUP',
  'BETWEEN',
  'BIGINT',
  'BINARY',
  'BIT',
  'BLANKSASNULL',
  'BOOLEAN',
  'BOTH',
  'BYTEDICT',
  'CASE',
  'CAST',
  'CHAR',
  'CHARACTER',
  'CHECK',
  'COALESCE',
  'COLLATE',
  'COLUMN',
  'CONSTRAINT',
  'CREATE',
  'CREDENTIALS',
  'CROSS',
  'CURRENT_CATALOG',
  'CURRENT_DATE',
  'CURRENT_ROLE',
  'CURRENT_TIME',
  'CURRENT_TIMESTAMP',
  'CURRENT_USER',
  'CURRENT_USER_ID',
  'DEC',
  'DECIMAL',
  'DEFAULT',
  'DEFERRABLE',
  'DEFLATE',
  'DEFRAG',
  'DELTA',
  'DELTA32K',
  'DESC',
  'DISABLE',
  'DISTINCT',
  'DO',
  'ELSE',
  'EMPTYASNULL',
  'ENABLE',
  'ENCODE',
  'ENCRYPT',
  'ENCRYPTION',
  'END',
  'EXCEPT',
  'EXISTS',
  'EXPLICIT',
  'EXTRACT',
  'FALSE',
  'FETCH',
  'FLOAT',
  'FOR',
  'FOREIGN',
  'FREEZE',
  'FROM',
  'FULL',
  'GLOBALDICT256',
  'GLOBALDICT64K',
  'GRANT',
  'GREATEST',
  'GROUP',
  'GROUPING',
  'GZIP',
  'HAVING',
  'IDENTITY',
  'IGNORE',
  'ILIKE',
  'IN',
  'INITIALLY',
  'INNER',
  'INOUT',
  'INT',
  'INTEGER',
  'INTERSECT',
  'INTERVAL',
  'INTO',
  'IS',
  'ISNULL',
  'JOIN',
  'JSON',
  'JSON_ARRAY',
  'JSON_ARRAYAGG',
  'JSON_EXISTS',
  'JSON_OBJECT',
  'JSON_OBJECTAGG',
  'JSON_QUERY',
  'JSON_SCALAR',
  'JSON_SERIALIZE',
  'JSON_TABLE',
  'JSON_VALUE',
  'LATERAL',
  'LEADING',
  'LEAST',
  'LEFT',
  'LIKE',
  'LIMIT',
  'LOCALTIME',
  'LOCALTIMESTAMP',
  'LUN',
  'LUNS',
  'LZO',
  'LZOP',
  'MERGE_ACTION',
  'MINUS',
  'MOSTLY13',
  'MOSTLY32',
  'MOSTLY8',
  'NATIONAL',
  'NATURAL',
  'NCHAR',
  'NEW',
  'NONE',
  'NORMALIZE',
  'NOT',
  'NOTNULL',
  'NULL',
  'NULLIF',
  'NULLS',
  'NUMERIC',
  'OFF',
  'OFFLINE',
  'OFFSET',
  'OLD',
  'ON',
  'ONLY',
  'OPEN',
  'OR',
  'ORDER',
  'OUT',
  'OUTER',
  'OVERLAPS',
  'OVERLAY',
  'PARALLEL',
  'PARTITION',
  'PERCENT',
  'PLACING',
  'POSITION',
  'PRECISION',
  'PRIMARY',
  'RAW',
  'READRATIO',
  'REAL',
  'RECOVER',
  'REFERENCES',
  'REJECTLOG',
  'RESORT',
  'RESTORE',
  'RETURNING',
  'RIGHT',
  'ROW',
  'SELECT',
  'SESSION_USER',
  'SETOF',
  'SIMILAR',
  'SMALLINT',
  'SOME',
  'SUBSTRING',
  'SYMMETRIC',
  'SYSDATE',
  'SYSTEM',
  'TABLE',
  'TAG',
  'TDES',
  'TEXT255',
  'TEXT32K',
  'THEN',
  'TIME',
  'TIMESTAMP',
  'TO',
  'TOP',
  'TRAILING',
  'TREAT',
  'TRIM',
  'TRUE',
  'TRUNCATECOLUMNS',
  'UNION',
  'UNIQUE',
  'USER',
  'USING',
  'VALUES',
  'VARCHAR',
  'VARIADIC',
  'VERBOSE',
  'WALLET',
  'WHEN',
  'WHERE',
  'WINDOW',
  'WITH',
  'WITHOUT',
  'XMLATTRIBUTES',
  'XMLCONCAT',
  'XMLELEMENT',
  'XMLEXISTS',
  'XMLFOREST',
  'XMLNAMESPACES',
  'XMLPARSE',
  'XMLPI',
  'XMLROOT',
  'XMLSERIALIZE',
  'XMLTABLE',
])
